import React from "react";
import { Link, useParams } from "react-router-dom";
import AdminShell from "../../Components/admin/AdminShell";

export default function EditArticleStub() {
  const { articleId } = useParams();

  return (
    <AdminShell title="Edit article" subtitle="This screen is not built yet">
      <div className="adminCard" style={{ padding: 16 }}>
        <div style={{ fontWeight: 800, color: "#111827", marginBottom: 8 }}>Article id: {articleId}</div>
        <div style={{ color: "#6b7280", fontSize: 13, fontWeight: 600, lineHeight: 1.5 }}>
          Use PUT <code style={{ fontSize: 12 }}>/articles/editArticle/:id</code> (or <code style={{ fontSize: 12 }}>/api/articles/...</code>) with JSON and a Bearer token. Replace this page with a real editor when ready.
        </div>
        <div style={{ marginTop: 14 }}>
          <Link className="adminButton" to="/admin">
            Back to dashboard
          </Link>
        </div>
      </div>
    </AdminShell>
  );
}
